<template>
  <div
    class="device-wrapper"
    :class="[device === 'mobile'
      ? 'mobile-device' : 'desktop-device', fullPage ? 'large-device' : '']"
  >
    <div class="device">
      <div v-if="hasInvalidOrMultiplePlayers">
        <slot name="media-sheet"></slot>
      </div>
      <iframe
        id="demo-attach"
        v-else
        class="device-iframe"
        :src="demoUrl"
        :style="preventInteraction ? 'pointer-events: none' : ''"
      >
      </iframe>
      <img
        class="device-image"
        v-if="device === 'mobile'"
        src="../../assets/iphone-mockup.png"
        alt=""
      >
      <img
        class="device-image"
        v-if="device === 'desktop'"
        src="../../assets/browser-mockup.png"
        alt=""
      >
    </div>
    <div
      class="icons"
      v-if="showIcons"
    >
      <slot>
        <a @click="device = 'mobile'"><i
            class="fas fa-mobile"
            :class="device === 'mobile' ? 'selected-class' : ''"
          ></i></a>
        <a @click="device = 'desktop'"><i
            class="fa fa-desktop"
            :class="device === 'desktop' ? 'selected-class' : ''"
          ></i></a>
        <a
          :href="url"
          target="_blank"
        ><i class="fa fa-link"></i></a>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    preventInteraction: Boolean,
    fullPage: Boolean,
    deviceTypeOverwrite: String,
    url: String,
    showIcons: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      deferDemoUrl: false,
      device: 'mobile',
    };
  },
  computed: {
    isBuildMode() {
      return window.top.location.href.includes('attach-studio/build');
    },
    demoUrl() {
      if (this.deferDemoUrl) return;

      return `${this.url}&buildView=true`;
    },
    mobileFormVisible() {
      return this.$store.state.attachStudio.mobileFormVisible;
    },
    hasInvalidOrMultiplePlayers() {
      const multipleExperiences = this.$store.state.mediaSheet.hasMultipleInvalidExperiences;
      const invalidPlayer = this.$store.state.mediaSheet.isInvalidPlayer;

      return multipleExperiences || invalidPlayer;
    },
  },
  watch: {
    mobileFormVisible() {
      this.deferDemoUrl = true;
      setTimeout(() => {
        this.deferDemoUrl = false;
      }, 1000);
    },
    deviceTypeOverwrite() {
      this.device = this.deviceTypeOverwrite;
    },
  },
};

</script>

<style scoped>
.device {
  position: relative;
  margin: 0 auto;
  height: 609px;
}

.mobile-device .device {
  width: 300px;
}

.desktop-device .device {
  width: 414px;
}

.device-image {
  width: inherit;
  z-index: -1;
}

.large-device.desktop-device .device {
  transform: scale(1.4);
  pointer-events: none;
}

.desktop-device .device-image {
  margin-top: 138px;
  width: 425px;
  margin-left: 16px;
  z-index: 3;
  border: 2px solid #DDE1E5;
  border-bottom: none;
  border-top: none;
  border-radius: 10px 10px 0 0;
}

.large-device.desktop-device .device-image {
  margin-left: -8px;
}

.device-iframe {
  position: absolute;
  pointer-events: all;
}

.mobile-device .device-iframe {
  width: 319px;
  height: 486px;
  -ms-transform: scale(0.8);
  transform: scale(0.8);
  top: 63px;
  left: -11px;
  border: 1px solid #cacaca;
  border-bottom: none;
  border-top: none;
}

.desktop-device .device-iframe {
  width: 1289px;
  height: 800px;
  transform: scale(0.32);
  -ms-transform: scale(0.32);
  top: -91px;
  left: -440px;
  padding: 15px 20px;
  border: 6px solid #DDE1E5;
  border-radius: 0 0 10px 10px;
  border-top: none;
}

.large-device.desktop-device .device-iframe {
  left: -464px;
}

.mobile-form-toggle {
  display: none;
}

@media only screen and (max-width: 770px) {
  .mobile-form-toggle {
    display: block;
    position: fixed;
    z-index: 2;
    right: 12px;
    top: 12px;
    border-radius: 25px;
    font-size: 18px;
    padding: 4px 18px;
    color: #565656;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
    background: #f1f1f1;
  }

  .mobile-device .device-image {
    display: none;
  }

  .mobile-device .device-iframe {
    border: none;
    margin-top: 63px;
    transform: none;
    margin-left: -10px;
    position: fixed;
    top: 0;
    margin: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
}

.icons {
  display: block;
  font-size: 17px;
  margin-left: -12px;
  text-align: center;
  color: #d4d4d4;
}

.icons a {
  color: #b1adad;
  text-decoration: none;
  cursor: pointer;
}

.fab,
.fas,
.fa {
  cursor: pointer;
}

i {
  font-size: 16px;
  margin: 4px;
}

.selected-class {
  color: #668cf5;
}
</style>
